<template>
  <div>
    <baseEdit />
  </div>
</template>

<script>
  import baseEdit from './baseEdit';

  export default {
    name: 'wareHouseContractAdd',
    components: {
      baseEdit,
    },
  };
</script>
